import { render, staticRenderFns } from "./ListarAgrupadores.vue?vue&type=template&id=7068ac2a"
import script from "./ListarAgrupadores.vue?vue&type=script&lang=js"
export * from "./ListarAgrupadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports